import React, { useContext, useState, useEffect } from "react"
import { Link } from "gatsby"
import clsx from "clsx"
import QuickBuyContext from "@context/QuickBuyContext"
import NavBar from "./NavBar"
import MainMenu from "./MainMenu"
import IconMenu from "./IconMenu"
import MegaMenu from "./MegaMenu"
import MegaSearch from "./MegaSeach"
import CollabMenu from "./CollabMenu"

import bbLogo from "@images/Home/blackbough-logo.svg"

const MenuBar = () => {
	const [openMegaMenu, setOpenMegaMenu] = useState(false)
	const [openCollabMenu, setOpenCollabMenu] = useState(false)
	const [openSearch, setOpenSearch] = useState(false)
    const [scrollY, setScrollY] = useState(0);

	const { forceHideMenuBar, setAreHeaderMenusOpen } =
		useContext(QuickBuyContext)
	const inProductsPage =
		typeof window !== "undefined" &&
		window.location.href.indexOf("products") > -1

	const handleMegaMenu = (val) => {
		if(!openMegaMenu) setOpenCollabMenu(false)
		setOpenMegaMenu(val)
	}

	const handleCollabMenu = (val) => {
		if(!openCollabMenu) setOpenMegaMenu(false)
		setOpenCollabMenu(val)
	}
	
	const handleSearchBar = () => {
		setAreHeaderMenusOpen(!openSearch)
		setOpenSearch(!openSearch)
	}

    useEffect(() => {
        const handleScroll = () => setScrollY(window.scrollY);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

	return (
		<React.Fragment>
			<div
				className={`relative ${
					(forceHideMenuBar && inProductsPage && scrollY >= 10) && "block lg:hidden"
				}`}
			>
				<section className="relative flex gap-x-6 bg-white px-2 md:px-4 py-6 sm:px-3.5 h-14 text-white text-sm">
					<div className="relative flex items-center justify-between max-w-[1440px] mx-auto flex-1">
						<div className="relative flex flex-row-reverse lg:flex-row items-center">
							<Link to={"/"} aria-label="Home">
								<img
									className="w-32 md:w-40 ml-0 mt-1"
									src={bbLogo}
									alt={"Blackbough Swim"}
								/>
							</Link>
							<div className="hidden lg:flex">
								<MainMenu
									openMegaMenu={openMegaMenu}
									handleMenu={handleMegaMenu}
									openCollabMenu={openCollabMenu}
									handleCollabMenu={handleCollabMenu}
								/>
							</div>
							<NavBar />
						</div>

						<IconMenu handleSearchBar={() => handleSearchBar()} />
					</div>
				</section>

				<div className={clsx('relative flex bg-white')}>
					<MegaMenu isOpen={openMegaMenu} handleMegaMenu={handleMegaMenu} />
					<CollabMenu isOpen={openCollabMenu} handleCollabMenu={handleCollabMenu} />
				</div>
				<div
					className={clsx('relative flex bg-white', openCollabMenu ? "block" : "hidden")}
				>
					<CollabMenu handleCollabMenu={handleCollabMenu} />
				</div>

				<div
					className={`w-full max-container bg-white ${
						openSearch ? "block" : "hidden"
					}`}
				>
					<MegaSearch
						isOpen={openSearch}
						onClose={() => {
							setAreHeaderMenusOpen(false)
							setOpenSearch(false)
						}}
					/>
				</div>
			</div>
		</React.Fragment>
	)
}

export default MenuBar
